import React, { useState , useEffect} from 'react';
import styles from './dwn-style.module.css'; 
import { useLocation, useNavigate } from 'react-router-dom';


const Portal = () => {

const[access, setAccess] = useState(-1)
const location = useLocation();
const [pid] = useState(location?.state?.pid )
const [uid] = useState(location?.state?.uid )
const [fitbitStatus, setFitbitStatus] = useState("")
const [upcomingMeetings, setUpcomingMeetings] = useState([]);
const [role, setRole] = useState(location?.state?.role)
const [other_uid, setOtherUID] = useState("")


const navigate = useNavigate();


const authorizeFitbit = () =>{
  const scope = "participant"
   window.location.href = "https://app.digitalwellnessnurse.com:/api/fitbit/authorize/"+pid;
   //window.location.href = "http://localhost:2001/api/fitbit/authorize/"+pid+"/"+scope;

}

const signOut = () => {


  const body = {}
  let connectionString = "https://app.digitalwellnessnurse.com"  //https://app.digitalwellnessnurse.com  http://localhost:2001
  fetch(connectionString+'/api/portal/signout', {
      method: 'POST',
      headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      },
      credentials: "include",
      body: JSON.stringify(body),
  }).then((response) => {
    
      if(response.status == 200){

        navigate('/');
        

      }

      
  }
  ).catch((error) => {
      console.log(error)
  })



}

const revokeFitbit = () =>{

  const body = {"username": pid}
  let connectionString = "https://app.digitalwellnessnurse.com"    //https://app.digitalwellnessnurse.com  http://localhost:2001
  fetch(connectionString+'/api/portal/fitbit/revoke/', {
      method: 'POST',
      headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      },
      credentials: "include",
      body: JSON.stringify(body),
  }).then((response) => {
    

      if(response.status == 204){

        setFitbitStatus("authorize")

      }
      else if(response.status == 401){

        navigate('/');

      }
      else
      {

      }

      
  }
  ).catch((error) => {
      console.log(error)
  })




}

const getFormattedDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(today.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const getUpcomingMeetings = async () => {
  const body = { pid: pid, date: getFormattedDate()}; // Assuming `pid` is available in the current scope
  let connectionString = "https://app.digitalwellnessnurse.com"; //https://app.digitalwellnessnurse.com  http://localhost:2001

  try {
    const response = await fetch(`${connectionString}/api/portal/get-meetings`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(body),
    });

    if (response.status === 200) {
      const data = await response.json();

      // Process meetings
      const formattedMeetings = await Promise.all(
        data.meetings.map(async (meeting) => {
          const profileDetails = await getProfile(meeting.invitation); // Call getProfile with invitation array
          const filteredProfiles = profileDetails.filter(profile => profile.uid !== uid);
          const otherUID = filteredProfiles.length > 0 ? filteredProfiles[0].uid : "";
          setOtherUID(otherUID)
          const otherParticipant = filteredProfiles.map(person => `${person.firstName} ${person.lastName}`).join(", ");
          return {
            id: meeting._id,
            date: new Date(meeting.meeting_time).toLocaleDateString('en-US', { timeZone: 'UTC' }),// Specify the time zone
            time: new Date(meeting.meeting_time).toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                second: undefined,
                timeZone: 'UTC'
            }),

            participants: otherParticipant, // Replace `invitation` with profiles
          };
        })
      );

      setUpcomingMeetings(formattedMeetings);
    } else {
      console.error("Failed to retrieve meetings:", response.status);
    }
  } catch (error) {
    console.error("Error fetching meetings:", error);
  }
};

const getRole = async () => {

  const connectionString = "https://app.digitalwellnessnurse.com"; //https://app.digitalwellnessnurse.com  http://localhost:2001
  
  try {
    const response = await fetch(`${connectionString}/api/portal/role`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ pid }),
    });

    if (response.status === 200) {
      const data = await response.json();
      setRole(data.role)// Return the profiles from the backend
    } else {
      console.error("Failed to retrieve profiles:", response.status);
      return [];
    }
  } catch (error) {
    console.error("Error fetching profiles:", error);
    return [];
  }
};

const getProfile = async (pids) => {

  const connectionString = "https://app.digitalwellnessnurse.com"; //https://app.digitalwellnessnurse.com  http://localhost:2001
  
  try {
    const response = await fetch(`${connectionString}/api/portal/getProfiles`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ pids }),
    });

    if (response.status === 200) {
      const data = await response.json();
      return data.profiles; // Return the profiles from the backend
    } else {
      console.error("Failed to retrieve profiles:", response.status);
      return [];
    }
  } catch (error) {
    console.error("Error fetching profiles:", error);
    return [];
  }
};

const onboarded_families = () => {
  navigate('/FitOnboardedDashboard', { state: {pid: pid} });
};


useEffect(() => {
  if (pid == null) {
    navigate('/');
  } else {
    const body = { "username": pid, "scope": "participant" };
    let connectionString = "https://app.digitalwellnessnurse.com"; //https://app.digitalwellnessnurse.com  http://localhost:2001

    fetch(`${connectionString}/api/portal/verify`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: "include",
      body: JSON.stringify(body),
    })
      .then((response) => {
        setAccess(response.status);
        return response.json();
      })
      .then((json) => {
        if (json.access === 200) {
          setFitbitStatus(json.fitbit.status);

          // Fetch meetings after verifying access
          getUpcomingMeetings();
        } else {
          navigate('/');
        }
      })
      .catch((error) => {
        console.error("Error verifying access:", error);
      });
  }
   }, [pid, navigate]); // Dependency array ensures this effect runs only when `pid` or `navigate` changes.

   useEffect(() => {
    if (pid) {
      getRole();
    }
  }, [pid]); 


  const handleJoin = (meeting_id) => {

    navigate('/Meeting', { state: {pid: pid, uid:uid, meeting_id: meeting_id, role:role, other_uid: other_uid} })

  }  
  
  const handleCancel = async (meetingId, setMeetings) => {
    if (!meetingId || typeof meetingId !== 'string') {
      console.error("Invalid meetingId provided to handleCancel.");
      return;
    }
  
    try {
      const response = await fetch('/api/meetings/cancel-meeting', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ meetingId }),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error canceling meeting:", errorData.error);
        alert(errorData.error || "Failed to cancel the meeting.");
        return;
      }
  
      const responseData = await response.json();
  
      // Update the UI (assumes `setMeetings` removes the canceled meeting)
      setMeetings((prevMeetings) =>
        prevMeetings.filter((meeting) => meeting._id !== meetingId)
      );
  
      alert("Meeting successfully canceled.");
    } catch (error) {
      console.error("Network error while canceling meeting:", error);
      alert("Unable to cancel the meeting due to a network error.");
    }
  };
  


  if(access == -1){
    return (
        <div className={styles.center}>
            <div class="loader"></div>
        </div>
    )
  }
  else if(access == 401){
    navigate('/')
  }
  return (
      <div className={styles.portal}>
        {/* Top Navigation */}
        <div className={styles.topRight}>
          <button onClick={signOut} type="button" className={styles.buttonLink}>
            Sign Out
          </button>
        </div>
  
        {/* Fitbit Section */}
        <div className={styles.left}>
        {role === "Member" && (
          <button
            onClick={fitbitStatus === "revoke" ? revokeFitbit : authorizeFitbit}
            type="button"
            className={styles.fitbitBttn}
          >
            {fitbitStatus === "revoke" ? "Revoke Fitbit Access" : "Authorize Fitbit Access"}
          </button>
           )}
        </div>
        <div className={styles.upcomingMeetingsPanel}>
          <h2 className={styles.panelTitle}>Upcoming Meetings</h2>
          {upcomingMeetings.map((meeting) => (
            <div key={meeting._id} className={styles.meetingCard}>
              <div className={styles.meetingDetails}>
                <div className={styles.meetingDate}>
                  {meeting.date}
                </div>
                <div className={styles.meetingTime}>
                  {meeting.time}
                </div>
                <div className={styles.meetingParticipants}>
                  With: {meeting.participants}
                </div>
              </div>
              <div className={styles.meetingButtons}>
                <button className={styles.joinButton} onClick={() => handleJoin(meeting.id)}>
                  Join
                </button>
                {role === "Provider" && (
                  <button className={styles.cancelButton} onClick={() => handleCancel(meeting.id, setUpcomingMeetings)}>
                    Cancel
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      {/* Onboard Families Section (Providers Only) */}
      {role === "Provider" && (
          <div className={styles.onboardFamiliesSection}>
            <h2 className={styles.panelTitle}>Families Onboarded</h2>
            <button
              onClick={onboarded_families}
              className={styles.mainButton}
              style={{
                backgroundColor: "#2F5597",
                color: "white",
                fontSize: "18px",
                padding: "15px 30px",
              }}
            >
              Participating Families
            </button>
          </div>
        )}
      </div>
  );
    
  




}

export default Portal;